// This file is automatically generated. DO NOT EDIT.

import { type PinOnImageResult } from '../../../../types/response/PinOnImageResult';
import { getJSONResponse, type GetJSONResponseOptions } from '@api/internal';

export interface GetPinOnImageResultsResponse {
  /** The pin-on-image results */
  results: Array<PinOnImageResult>;
}

export async function getPinOnImageResultsResponse(
  response: Response,
  options?: GetJSONResponseOptions<GetPinOnImageResultsResponse>,
): Promise<GetPinOnImageResultsResponse> {
  return getJSONResponse<GetPinOnImageResultsResponse>(
    response,
    'getPinOnImageResultsResponse',
    options,
  );
}
